import {
  type CampaignDesiredStateDto,
  type CampaignConfigurationControllerCreateApiArg,
  type CampaignsControllerUpdateApiArg,
  type CampaignConfigurationControllerDeleteApiArg,
  type CampaignConfigurationControllerUpdateApiArg,
} from 'src/store/generated/leela-api-generated';

interface Unwrap<T> { unwrap: () => Promise<T> }

export async function createExclusionList (
  gti: string,
  campaignId: string,
  campaign: CampaignDesiredStateDto,
  createConfig: (arg: CampaignConfigurationControllerCreateApiArg) => Unwrap<{ id: string }>,
  updateCampaign: (arg: CampaignsControllerUpdateApiArg) => Unwrap<unknown>,
  deleteConfig: (arg: CampaignConfigurationControllerDeleteApiArg) => Unwrap<unknown>,
): Promise<void> {
  const newConfig = await createConfig({
    createCampaignConfigurationDto: {
      name: `${campaignId}_exclusionList`,
      config: { configType: 'GTI_BLOCKLIST', gtis: [gti] },
      source: 'SYSTEM',
    },
  }).unwrap();
  try {
    await updateCampaign({
      id: campaignId,
      updateCampaignDto: {
        priority: 'IMMEDIATE',
        programId: campaign.programId,
        publisher: campaign.publisher,
        exclusionListId: newConfig.id,
        configIds: [...(campaign.configIds ?? []), newConfig.id],
      },
    }).unwrap();
  } catch {
    await deleteConfig({ id: newConfig.id }).unwrap().catch(() => {});
    throw new Error('Campaign update failed');
  }
}

export async function addToExclusionList (
  gti: string,
  exclusionListId: string,
  currentGtis: string[],
  updateConfig: (arg: CampaignConfigurationControllerUpdateApiArg) => Unwrap<unknown>,
): Promise<void> {
  await updateConfig({
    id: exclusionListId,
    updateCampaignConfigurationDto: {
      config: { configType: 'GTI_BLOCKLIST', gtis: [...currentGtis, gti] },
    },
  }).unwrap();
}

export async function removeFromExclusionList (
  gti: string,
  exclusionListId: string,
  currentGtis: string[],
  updateConfig: (arg: CampaignConfigurationControllerUpdateApiArg) => Unwrap<unknown>,
): Promise<void> {
  await updateConfig({
    id: exclusionListId,
    updateCampaignConfigurationDto: {
      config: { configType: 'GTI_BLOCKLIST', gtis: currentGtis.filter((g) => g !== gti) },
    },
  }).unwrap();
}
